import type { RouteRecordRaw } from 'vue-router';

import { JUMIO_REGULARIZATION_VERIFY_PATH } from '@/shared/jumioRegularization/constants/jumioRegularization.constant';

const PublicLayout = () =>
  import('@/shared/layouts/pages/PublicLayout/index.vue');
const RegularizationVerify = () =>
  import('@/shared/jumioRegularization/pages/RegularizationVerify/index.vue');

export const jumioRegularizationPublicRoutes: Array<RouteRecordRaw> = [
  {
    path: `/${JUMIO_REGULARIZATION_VERIFY_PATH}`,
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'jumio-regularization-verify',
        component: RegularizationVerify,
      },
    ],
  },
];
